module.exports = __webpack_public_path__ + "img/3.72bd971a.jpg";